# constants used throughout the site in different places
MOBILE_WIDTH = 768
TABLET_WIDTH = 992
MD_WIDTH = 1200

DEFAULT_PASSWORD_MESSAGE = "Almost there, at least 6 characters please"
DEFAULT_AGREE_MESSAGE = "Please agree to the terms to continue"

# Email validator
EMAIL_VALIDATOR = /^.+@[^.].*\.[a-z]{2,10}$/

# mapping of model type to their human name
MODEL_TO_HUMAN_NAME = {
    companies: "Companies",
    jobs: "Jobs",
    posts: "Articles",
    coaches: "Coaches",
    tags: "Tags"
}

# mapping of model type to their respective urls
MODEL_TYPE_TO_URL = {
    "companies": "/companies",
    "jobs": "/jobs",
    "posts": "/advice",
    "coaches": "/coaches",
    "tags": "/tags"
}

MODEL_TO_SINGULAR = {
    companies: "company",
    jobs: "job",
    posts: "post",
    coaches: "coach",
    tags: "tag"
}

isIos = window.navigator.platform in ['iPad', 'iPhone', 'iPod']

isHeadlessBrowser = /(PhantomJS)|(MuseHeadlessTest)/.test(window.navigator.userAgent)

FLEXIBLE_LOCATION = "Flexible / Remote"

# static list of most popular locations at the muse
POPULAR_LOCATIONS = [
    "New York City Metro Area",
    "San Francisco Bay Area",
    "Los Angeles, CA",
    "Chicago, IL",
    "Flexible / Remote",
    "Washington DC Metro Area",
    "Austin, TX",
    "Boston Metro Area",
    "Atlanta, GA"
]

# static list of job levels
JOB_LEVELS = [
    "Internship",
    "Entry Level",
    "Mid Level",
    "Senior Level"
]

RELATED_AND_INFINITE_EXPERIMENT_POSTS = {
    "5290": {
        "articles": [9447, 9436, 7611, 8011]
    },
    "4138": {
        "articles": [3650, 7605, 4807, 4743, 9326]
    },
    "6279": {
        "articles": [7109, 8464, 7331, 8614]
    },
    "3734": {
        "articles": [9316, 7501, 490, 3988]
    },
    "3891": {
        "articles": [8470, 8669, 3720, 3478]
    },
    "4511": {
        "articles": [4570, 7069, 3016, 9310, 8710]
    },
    "4125": {
        "articles": [3952, 7104, 7114, 4900, 7260]
    }
}

EMAIL_CAPTURE_CLOSE_COOKIE = "email-capture-close"
EMAIL_CAPTURE_SUCCESS_COOKIE = "__tm_email_capture"
POST_ONBOARDING_COOKIE = "__tm_post_onboarding_completed"
HOME_ONBOARDING_COOKIE = "__tm_home_onboarding_completed"

module.exports = {
    MOBILE_WIDTH: MOBILE_WIDTH,
    TABLET_WIDTH: TABLET_WIDTH,
    MD_WIDTH: MD_WIDTH,
    DEFAULT_PASSWORD_MESSAGE: DEFAULT_PASSWORD_MESSAGE,
    DEFAULT_AGREE_MESSAGE: DEFAULT_AGREE_MESSAGE,
    MODEL_TO_HUMAN_NAME: MODEL_TO_HUMAN_NAME,
    MODEL_TYPE_TO_URL: MODEL_TYPE_TO_URL,
    MODEL_TO_SINGULAR: MODEL_TO_SINGULAR,
    isIos: isIos,
    POPULAR_LOCATIONS: POPULAR_LOCATIONS,
    FLEXIBLE_LOCATION: FLEXIBLE_LOCATION,
    JOB_LEVELS: JOB_LEVELS,
    EMAIL_VALIDATOR: EMAIL_VALIDATOR,
    RELATED_AND_INFINITE_EXPERIMENT_POSTS: RELATED_AND_INFINITE_EXPERIMENT_POSTS,
    EMAIL_CAPTURE_CLOSE_COOKIE: EMAIL_CAPTURE_CLOSE_COOKIE,
    EMAIL_CAPTURE_SUCCESS_COOKIE: EMAIL_CAPTURE_SUCCESS_COOKIE,
    POST_ONBOARDING_COOKIE: POST_ONBOARDING_COOKIE,
    HOME_ONBOARDING_COOKIE: HOME_ONBOARDING_COOKIE,
    isHeadlessBrowser: isHeadlessBrowser
}


// WEBPACK FOOTER //
// ./node_modules/musecoreui/consts.coffee